
import React from 'react';
import { Accordion, AccordionItem as Item } from '@szhsin/react-accordion';
import chevronDown from "../../assets/images/chevron-down.svg";
import { useGetFaq } from './api/api';
import PropTypes from 'prop-types';


const AccordionItem = ({ header, ...rest }) => (
    <Item
      {...rest}
      header={
        <>
          {header}
          <img className="chevron-down" src={chevronDown} alt="Chevron Down" />
        </>
      }
    />
);

const FaqPage = () => {
  const {data:getFaq}=useGetFaq()

  
  return (
    <div className='faqWizard'>            
            
            <Accordion transition transitionTimeout={250}>
             {getFaq?.data?.map(({ question, answer }, i) => (
                <AccordionItem header={question} key={question?._id}>
                {answer}
                </AccordionItem>
            ))}
            </Accordion>
            
   </div>
  )
}

AccordionItem.propTypes = {
  header: PropTypes.any.isRequired,
};


export default FaqPage;